import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "nail_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

const ADMIN_MODE_KEY = "nail_rater_admin_mode";
const ADMIN_SECRET = "Hexgo-NipobjqvKeCvbYxCk4abz-Rarg";

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (localStorage.getItem(ADMIN_MODE_KEY) === "true") {
    config.headers["X-Admin-Token"] = ADMIN_SECRET;
  }
  return config;
});

export const fileUrl = (path) => {
  if (!path) return null;
  const t = localStorage.getItem(TOKEN_KEY);
  return `${API}/files/${path}?auth=${t}`;
};
